import React, { useEffect, useMemo, useState } from 'react';
import { getCookie } from 'hooks/useCookie';
import Modal from '@/components/Modals/Modal';
import DisclaimerModalContent from 'components/Modals/DisclaimerModalContent';

const DisclaimerModal = ({ layoutData }) => {
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  const toggleDisclaimer = (): void => {
    setShowDisclaimerModal((prev) => !prev);
  };

  const pageDisclaimer = useMemo(() => {
    if (typeof document === 'undefined' || layoutData.sitecore.context.pageEditing) return false;
    const sitecoreContext = layoutData.sitecore.context;
    const disclaimer = sitecoreContext.disclaimer;
    if (!disclaimer) return false;
    const siteName = sitecoreContext.site.name;
    const languageVersion = sitecoreContext.language;

    const disclaimerCookies = JSON.parse(getCookie('abrdn-disclaimer') || null);

    if (disclaimerCookies) {
      const currentSiteCookie = disclaimerCookies.find(
        (cookie) => cookie.n === siteName && cookie.l === languageVersion
      );
      if (!currentSiteCookie) return disclaimer;
      //const isSessionBased = disclaimer.session.value;
      const isSessionBased = false;
      if (isSessionBased) {
        const currentSessionId = getCookie('ASP.NET_SessionId');
        return currentSessionId !== currentSiteCookie.s ? disclaimer : false;
      } else {
        const date = new Date();
        const currentDate = date.getTime();
        return currentDate > (currentSiteCookie.e || 0) ? disclaimer : false;
      }
    }
    return disclaimer;
  }, [layoutData.sitecore.context]);

  useEffect(() => {
    if (pageDisclaimer) {
      setShowDisclaimerModal(true);
    }
  }, [pageDisclaimer]);

  return (
    <>
      {pageDisclaimer && (
        <Modal
          isModalOpen={showDisclaimerModal}
          onCloseModal={toggleDisclaimer}
          renderContent={showDisclaimerModal}
          closeMethods={[]}
        >
          <DisclaimerModalContent
            context={layoutData.sitecore.context}
            fields={pageDisclaimer}
            closeModal={toggleDisclaimer}
          />
        </Modal>
      )}
    </>
  );
};

export default DisclaimerModal;
